module.exports = __webpack_public_path__ + "static/media/useCase63x.18a816c2.png";